import { Button, Input, Text, useDisclosure } from "@chakra-ui/react";
import { useCallback, useState } from "react";
import { LuUpload } from "react-icons/lu";
import FileUpload from "@/ui/inputs/FileUpload";
import {
  replenishmentApi,
  ReplenishmentScanResponse,
} from "@/shared/core-replenishments";
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/ui/chakra/dialog";
import { toast } from "@/ui/chakra/toaster";

interface DialogInvoiceScanProps {
  onSucess?: (res: ReplenishmentScanResponse, file: File | null) => void;
  buttonLabel?: string;
}

const DialogInvoiceScan: React.FC<DialogInvoiceScanProps> = ({
  onSucess,
  buttonLabel = "Subir archivo",
}) => {
  const { open, onOpen, onClose } = useDisclosure();
  const [invoiceFile, setInvoiceFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleOnSubmitInvoice = async () => {
    if (!invoiceFile) return;
    setIsLoading(true);
    try {
      const res = await replenishmentApi.scan(invoiceFile);
      onSucess && onSucess(res, invoiceFile);
      onClose();
    } catch (error) {
      console.error("Error al escanear la factura:", error);
      toast({
        title: "No se pudo escanear la factura",
        description: "Revisa el archivo e inténtalo nuevamente.",
        status: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnChangeFile = (e: HTMLInputElement | null) => {
    if (!e?.files?.length) return;
    setInvoiceFile(e.files[0]);
    onOpen();
  };

  const handleOnClose = useCallback(() => {
    setInvoiceFile(null);
    onClose();
  }, [onClose]);

  return (
    <>
      <FileUpload accept=".pdf" onChange={handleOnChangeFile}>
        <Button variant="outline" size="sm" type="button">
          <LuUpload />
          {buttonLabel}
        </Button>
      </FileUpload>

      <DialogRoot
        isOpen={open}
        onClose={handleOnClose}
        role="alertdialog"
        isCentered
        size="sm"
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Escanear factura</DialogTitle>
          </DialogHeader>
          <DialogBody display="flex" flexDirection="column" gap={3}>
            <Text fontSize="sm" color="fg.muted">
              Se leerá la factura para completar el RUT del proveedor, el número
              de factura y los productos. Podrás revisarlos antes de guardar.
            </Text>
            <Input value={invoiceFile?.name ?? ""} readOnly bg="bg.subtle" />
          </DialogBody>
          <DialogFooter>
            <Button variant="outline" onClick={handleOnClose} type="button">
              Cancelar
            </Button>
            <Button
              colorPalette="brand"
              onClick={handleOnSubmitInvoice}
              loading={isLoading}
              type="button"
            >
              Continuar
            </Button>
          </DialogFooter>
        </DialogContent>
      </DialogRoot>
    </>
  );
};
export default DialogInvoiceScan;
